import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import { WaterTextureOverlayImage } from './WaterTextureOverlay.styles';
import { IStaticContentfulFileURLs } from 'src/types/contentful';

interface WaterTextureOverlayProps {
  opacity?: number;
}

const WaterTextureOverlay = ({ opacity = 0.1 }: WaterTextureOverlayProps): JSX.Element => {
  const { backgroundImage }: IStaticContentfulFileURLs = useStaticQuery(graphql`
    {
      backgroundImage: contentfulAsset(contentful_id: { eq: "4WzzpEQUXCoi7inzXB15rR" }) {
        file {
          url
        }
      }
    }
  `);

  return (
    <WaterTextureOverlayImage
      className='water-texture-overlay'
      backgroundImageUrl={backgroundImage.file?.url}
      opacity={opacity}
    />
  );
};

export default WaterTextureOverlay;

